// extracted by mini-css-extract-plugin
export default {"rsnipTextArea":"RSNIPDisclosureText_rsnipTextArea__yAzhp"};